export default function (itemsCount, page = 1, size = 10) {
  // calculate total pages
  const pagesCount = Math.ceil(itemsCount / size)

  // ensure current page isn't out of range
  if (page < 1) {
    page = 1
  } else if (page > pagesCount) {
    page = pagesCount
  }

  let start
  let end
  if (pagesCount <= 10) {
    // less than 10 total pages so show all
    start = 1
    end = pagesCount
  } else {
    // more than 10 total pages so calculate start and end pages
    if (page <= 6) {
      start = 1
      end = 10
    } else if (page + 4 >= pagesCount) {
      start = pagesCount - 9
      end = pagesCount
    } else {
      start = page - 5
      end = page + 4
    }
  }

  // calculate start and end item indexes
  const startIndex = (page - 1) * size
  const endIndex = Math.min(startIndex + size - 1, itemsCount - 1)

  // create an array of pages to ng-repeat in the pager control
  const pages = Array.from(Array(end + 1 - start).keys()).map(i => start + i)

  // return object with all pager properties required by the view
  return {
    itemsCount,
    page,
    size,
    pagesCount,
    start,
    end,
    startIndex,
    endIndex,
    pages,
  }
}

export function calculateOffset(pagination, pageNumber) {
  return {
    page: pageNumber,
    offset: (pagination.page - 1) * pagination.size,
  }
}
